// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-module--footer--R2bpz","love":"footer-module--love--1n4WA","pageFooter":"footer-module--page-footer--2uGST"};